module.exports = __webpack_public_path__ + "img/plan-list.efda5866.svg";